import TTechnicianType from "rules/enums/profile/technician-type.enum";
import IUserToken from "rules/interface/user/tokens.interface";
import IUserVerify from "rules/interface/user/verify.interface";

class TechnicianTokenService {
  getTokens(): IUserToken[] {
    if (typeof window !== "undefined" && window.localStorage.getItem("technician") !== 'undefined') {
      const technician: IUserVerify = JSON.parse(window.localStorage.getItem("technician"))
      return technician?.token ?? [];
    }
  }
  getToken(tokenType: TTechnicianType): IUserToken | undefined {
    return this.getTokens()?.find(item => item.type === tokenType) ?? undefined
  }
  getFirstToken(): IUserToken | undefined {
    return this.getTokens()?.[0] ?? undefined
  }
  setTechnician(technician: IUserVerify) {
    localStorage.setItem("technician", JSON.stringify(technician));
  }
  removeUser() {
    localStorage.removeItem("technician");
  }
}
export default new TechnicianTokenService();
